import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
    Table,
    Pagination,
    PaginationItem,
    PaginationLink,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import "./SessionDetails.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEdit } from '@fortawesome/free-solid-svg-icons';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom";

const SessionForm = () => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [sessionName, setSessionName] = useState("");
    const [sessions, setSessions] = useState([]);
    const [applications, setApplications] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [size, setSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [statusType, setStatusType] = useState('CourseFeePaid');
    const [title, setTitle] = useState('');
    const [error, setError] = useState(null);
    const [pageSize] = useState(10);
    const location = useLocation();
    const [sessionKey, setsessionKey] = useState('')


    // Modal state for edit
    const [modal, setModal] = useState(false);
    const [editSession, setEditSession] = useState({ sessionName: '', fromDate: '', toDate: '' });

    const toggleModal = () => setModal(!modal);

    const getLatestToDate = () => {

        const validDates = sessions
            .map(session => new Date(session.toDate))
            .filter(date => !isNaN(date)); // Filter out invalid dates

        return validDates.length > 0 ? new Date(Math.max(...validDates)) : null;
    };
    const latestToDate = getLatestToDate();
    const formattedLatestDate = latestToDate ? latestToDate.toISOString().split("T")[0] : "";

    useEffect(() => {
        const fetchApplications = async () => {
            if (!statusType || !sessionKey) {
                return;
            }

            try {
                setLoading(true);
                const response = await axios.get(`${BaseUrl}/admin/fetchApplicationsession`, {
                    headers: {
                        Authorization: localStorage.getItem("$3ingT0k3n"),
                    },
                    params: {
                        statusType: statusType,
                        sessionKey: sessionKey
                    },
                });


                setApplications(response.data);
            } catch (error) {
                setError('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };

        fetchApplications();
    }, [statusType, sessionKey]);

    const saveSession = async () => {
        try {
            const sessionData = {
                fromDate,
                toDate,
                sessionName,
            };

            const response = await axios.post(
                `${BaseUrl}/admin/saveSession`,
                sessionData,
                {
                    headers: {
                        Authorization: `${localStorage.getItem("$3ingT0k3n")}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Session saved successfully");
                setFromDate("");
                setToDate("");
                setSessionName("");
                fetchSessions();
            }
        } catch (error) {
            toast.error(error.response ? error.response.data : "Failed to save session");
        }
    };



    const exportData = async () => {
        if (!applications || applications.length === 0) {

            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Registered Candidates');

        // Define worksheet columns
        worksheet.columns = [
            { header: 'Candidate Name', key: 'candidateName' },
            { header: 'Father Name', key: 'fatherName' },
            { header: 'Date of Birth', key: 'dob' },
            { header: 'Mobile Number', key: 'mobileNumber' },
            { header: 'Email', key: 'email' },
            { header: 'Address', key: 'address' },
            { header: 'Course', key: 'course' },
            { header: 'Enrolled Date', key: 'enrolled' },
            { header: 'Fee Paid', key: 'feePaid' },
            { header: 'Candidate Code', key: 'candidateCode' },
            { header: 'Session Name', key: 'sessionName' },
            { header: 'Reference Code', key: 'referenceCode' },
            { header: 'Is GJU Employee?', key: 'employee' },


        ];

        // Loop through each data entry
        for (const t of applications) {
            // Add a row with data
            const row = worksheet.addRow({
                candidateName: t.applicantName,
                fatherName: t.fatherName,
                dob: t.dob,
                mobileNumber: t.mobileNumber,
                email: t.email,
                address: t.address,
                course: t.course,
                enrolled: t.enrolledOn,
                feePaid: t.status === 'COURSE_FEE_PAID' ? 'Yes' : 'No',
                candidateCode: t.candidateCode,
                sessionName: t.sessionName,
                referenceCode: t.referenceCode,
                employee: t.employee ? 'Yes' : 'No',

            });


            let nextImageCol = 6;

            for (const [docIndex, doc] of t.documents.entries()) {
                try {

                    const imageBuffer = Buffer.from(doc.data, 'base64');


                    const mimeType = getMimeTypeFromByteArray(imageBuffer);
                    const extension = mimeType === 'image/jpeg' ? 'jpeg' : 'png';


                    const imageId = workbook.addImage({
                        buffer: imageBuffer,
                        extension: extension,
                    });


                    worksheet.addImage(imageId, {
                        tl: { col: nextImageCol, row: row.number - 1 },
                        ext: { width: 100, height: 100 }
                    });


                    nextImageCol++;
                } catch (error) {
                    console.error("Error adding image:", error);
                }
            }
        }


        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'CourseFeePaid.xlsx');
        } catch (error) {
            console.error("Error writing Excel file:", error);
        }
    };
    const getMimeTypeFromByteArray = (buffer) => {

        const arr = new Uint8Array(buffer).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
        }


        switch (header) {
            case "89504e47":
                return "image/png";
            case "ffd8ffe0":
            case "ffd8ffe1":
            case "ffd8ffe2":
            case "ffd8ffe3":
            case "ffd8ffe8":
                return "image/jpeg";
            default:
                return "application/octet-stream";
        }
    };

    const fetchSessions = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${BaseUrl}/admin/getAllSessions`, {
                params: { page: currentPage, size },
                headers: {
                    Authorization: `${localStorage.getItem("$3ingT0k3n")}`,
                },
            });

            const latestSession = response.data.response[0];

            setEditSession(latestSession);
            setSessions(response.data.response);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error("Error fetching sessions:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fromDate || !toDate || !sessionName) {
            toast.error("All fields are required.");
            return;
        }

        saveSession();
    };

    const handleEdit = (session) => {
        setEditSession(session);
        toggleModal();
    };

    const updatedSession = (sessionKey) => {
        setsessionKey(sessionKey);
    }

    const handleFromDateChange = (e) => {
        const selectedFromDate = e.target.value;
        setFromDate(selectedFromDate);


        setToDate("");

    };

    const handleUpdate = async () => {
        try {
            const updatedSession = {
                ...editSession,
                toDate: editSession.toDate,
                sessionName: editSession.sessionName,
            };

            const response = await axios.put(
                `${BaseUrl}/admin/updateSession`,
                updatedSession,
                {
                    headers: {
                        Authorization: `${localStorage.getItem("$3ingT0k3n")}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Session updated successfully");
                fetchSessions();
                toggleModal();
            }
        } catch (error) {
            toast.error("Failed to update session");
        }
    };

    useEffect(() => {
        fetchSessions();
    }, [currentPage]);

    return (
        <Container
            className="py-1 border rounded"
            style={{
                boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            }}
        >
            <div className="container">
                <h4 className="text-center mb-4">Session List</h4>



                <Table bordered hover responsive>
                    <thead className="thead-light">
                        <tr>
                            <th>#</th>
                            <th>Session Name</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions.length > 0 ? (
                            sessions.map((session, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{session.sessionName}</td>
                                    <td>{session.fromDate}</td>
                                    <td>{session.toDate}</td>
                                    <td>
                                        {session.toDate === sessions[0].toDate && (
                                            <button
                                                className="edit-icon-btn"
                                                onClick={() => handleEdit(session)}

                                                title="Edit Session"
                                            >
                                                <FontAwesomeIcon icon={faEdit} className="edit-icon" /> Edit
                                            </button>
                                        )}

                                        {title}
                                        {statusType === 'CourseFeePaid' && (
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    updatedSession(session.sessionKey);
                                                    exportData();
                                                }}
                                                className="export-button"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',

                                                    backgroundColor: '#4CAF50',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faDownload} className="export-icon" style={{ marginRight: '5px' }} /> {/* FontAwesome download icon */}
                                                Export
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    No sessions available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                <Row className="justify-content-center mt-4">
                    <Col md="auto">
                        <Pagination aria-label="Page navigation">
                            <PaginationItem disabled={currentPage === 0}>
                                <PaginationLink
                                    previous
                                    onClick={() => handlePageChange(currentPage - 1)}
                                />
                            </PaginationItem>
                            <PaginationItem>
                                <PaginationLink disabled>
                                    Page {currentPage + 1} of {totalPages}
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages - 1}>
                                <PaginationLink
                                    next
                                    onClick={() => handlePageChange(currentPage + 1)}
                                />
                            </PaginationItem>
                        </Pagination>
                    </Col>
                </Row>
            </div>

            <h2 className="text-center mb-4 form-heading">Create  Session</h2>
            <p className="text-center">Latest Session End Date: {formattedLatestDate}</p>
            <Form onSubmit={handleSubmit} className="session-form">
                <Row className="g-4">
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="sessionName" className="form-label">
                                Session Name:
                            </Label>
                            <Input
                                type="text"
                                id="sessionName"
                                value={sessionName}
                                onChange={(e) => setSessionName(e.target.value)}
                                className="form-input"
                                required
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="fromDate" className="form-label">
                                From Date:
                            </Label>
                            <Input
                                type="date"
                                id="fromDate"
                                value={fromDate}
                                onChange={handleFromDateChange}
                                // onChange={(e) => setFromDate(e.target.value)}
                                min={formattedLatestDate}
                                className="form-input"
                                required
                                disabled={modal}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label htmlFor="toDate" className="form-label">
                                To Date:
                            </Label>
                            <Input
                                type="date"
                                id="toDate"
                                min={fromDate}
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                disabled={!fromDate}
                                className="form-input"
                                required
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <div className="text-center mt-4">
                    <Button type="submit" className="custom-save-button">
                        <i className="fas fa-save"></i> Save Session
                    </Button>
                </div>
            </Form>




            <Modal isOpen={modal} toggle={toggleModal} backdrop="static" keyboard={false}>
                <ModalHeader toggle={toggleModal}>Edit Session</ModalHeader>
                <ModalBody>
                    {editSession && (
                        <Form>
                            <FormGroup>
                                <Label htmlFor="editSessionName">Session Name:</Label>
                                <Input
                                    type="text"
                                    id="editSessionName"
                                    value={editSession.sessionName || ''}
                                    onChange={(e) => setEditSession({ ...editSession, sessionName: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="editFromDate">From Date:</Label>
                                <Input
                                    type="date"
                                    id="editFromDate"
                                    value={editSession.fromDate || ''}
                                    disabled
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="editToDate">To Date:</Label>
                                <Input
                                    type="date"
                                    id="editToDate"
                                    value={editSession.toDate || ''}
                                    onChange={(e) => setEditSession({ ...editSession, toDate: e.target.value })}
                                    required
                                />
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                    <Button color="primary" onClick={handleUpdate}>Update</Button>
                </ModalFooter>
            </Modal>
        </Container>
    );
};

export default SessionForm;
